import { render, staticRenderFns } from "./CardCreate.vue?vue&type=template&id=39e123bf&"
import script from "./CardCreate.vue?vue&type=script&lang=js&"
export * from "./CardCreate.vue?vue&type=script&lang=js&"
import style0 from "./CardCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports